/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Achievementsbasegametooltip3Inputs */

const id_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar pencapaian ini untuk game dasar.`)
};

const ms_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senarai pencapaian ini adalah untuk permainan asas.`)
};

const da_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne liste af achievements er for basespillet.`)
};

const de_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Liste von Errungenschaften ist für das Basisspiel.`)
};

const en_us2_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This list of achievements are for the base game.`)
};

const es_es2_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta lista de logros es para el juego base.`)
};

const es_mx2_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta lista de logros es para el juego base.`)
};

const fil_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang listahang ito ng achievement ay para sa base game.`)
};

const fr_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette liste de succès concerne le jeu de base.`)
};

const it_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo elenco di risultati è per il gioco base.`)
};

const hu_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez a teljesítménylista az alapjátékhoz tartozik.`)
};

const nl_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze lijst met prestaties is voor het basisspel.`)
};

const no_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne listen over prestasjoner er for grunnspillet.`)
};

const pl_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta lista osiągnięć dotyczy gry podstawowej.`)
};

const pt_br2_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta lista de conquistas é para o jogo base.`)
};

const pt_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta lista de conquistas é para o jogo base.`)
};

const ro_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Această listă de realizări este pentru jocul de bază.`)
};

const fi_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä saavutuslista koskee peruspeliä.`)
};

const sv_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denna lista med prestationer är för grundspelet.`)
};

const vi_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách thành tích này dành cho game cơ bản.`)
};

const tr_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu başarım listesi temel oyun içindir.`)
};

const cs_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento seznam úspěchů je pro základní hru.`)
};

const bg_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Този списък с постижения е за основната игра.`)
};

const ru_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот список достижений для базовой игры.`)
};

const uk_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей список досягнень для базової гри.`)
};

const ar_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قائمة الإنجازات هذه للعبة الأساسية.`)
};

const hi_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्धियों की यह सूची बेस गेम के लिए है।`)
};

const th_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการความสำเร็จนี้สำหรับเกมหลัก`)
};

const ja_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この実績リストはベースゲーム用です。`)
};

const zh_cn2_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此列表显示的是基础游戏成就。`)
};

const zh_hant1_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此清單顯示的是基礎遊戲成就。`)
};

const ko_sandboxes_achievementsbasegametooltip3 = /** @type {(inputs: Sandboxes_Achievementsbasegametooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 도전 과제 목록은 기본 게임용입니다.`)
};

/**
* | output |
* | --- |
* | "This list of achievements are for the base game." |
*
* @param {Sandboxes_Achievementsbasegametooltip3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_achievementsbasegametooltip3 = /** @type {((inputs?: Sandboxes_Achievementsbasegametooltip3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Achievementsbasegametooltip3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "ms") return ms_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "da") return da_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "de") return de_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "en-US") return en_us2_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "fil") return fil_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "fr") return fr_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "it") return it_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "hu") return hu_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "nl") return nl_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "no") return no_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "pl") return pl_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "pt") return pt_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "ro") return ro_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "fi") return fi_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "sv") return sv_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "vi") return vi_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "tr") return tr_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "cs") return cs_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "bg") return bg_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "ru") return ru_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "uk") return uk_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "ar") return ar_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "hi") return hi_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "th") return th_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "ja") return ja_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_achievementsbasegametooltip3(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_achievementsbasegametooltip3(inputs)
	return ko_sandboxes_achievementsbasegametooltip3(inputs)
});
export { sandboxes_achievementsbasegametooltip3 as "sandboxes.achievementsBaseGameTooltip" }